<template>
  <div class="zcbody" v-loading="loading">
    <div class="zc-header">
      <div class="head" style="padding: 20px 0 30px 0">
        <div class="logo">
          <router-link :to="{ path: '/login' }"><img src="../../assets/images/logo.png"
              style="width: 80px" /></router-link>
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div class="z_heng">
        <ul>
          <li class="agreement active">
            <img src="../../assets/images/agreement2.png" /><span>注册协议</span>
          </li>
          <li class="information active">
            <img src="../../assets/images/information2.png" /><span>用户信息</span>
          </li>
          <li class="archives">
            <img src="../../assets/images/archives1.png" /><span>供货信息</span>
          </li>
          <li class="supply-object">
            <img src="../../assets/images/supply-object1.png" /><span>上传资质</span>
          </li>
          <li class="intelligence">
            <img src="../../assets/images/intelligence1.png" /><span>注册完成</span>
          </li>
        </ul>
      </div>
      <div class="protocol-title">供货信息</div>
      <div class="protocont">
        <el-form ref="ruleForm" :rules="rules" :model="form" label-width="110px" class="form01">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="公司名称:" prop="ccustomername">
                <el-input v-model="form.ccustomername" placeholder="请输入公司名称" @change="accout()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="信用代码:" prop="ccredit">
                <el-input v-model="form.ccredit" placeholder="请输入信用代码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="登录账户:" prop="caccount">
                <el-input v-model="form.caccount" placeholder="请输入登录账户"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公司简称:" prop="ccustomerabb">
                <el-input v-model="form.ccustomerabb" placeholder="请输入公司简称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="密码:" prop="cpassword">
                <el-input v-model="form.cpassword" type="password" placeholder="请输入密码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="密码确认:" prop="crepassword">
                <el-input v-model="form.crepassword" type="password" placeholder="请再次输入密码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="曾用名:" prop="cformername">
                <el-input v-model="form.cformername" placeholder="请输入曾用名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人:" prop="cvenoper">
                <el-input v-model="form.cvenoper" placeholder="请输入联系人真实姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机:" prop="ccustomerlinktel">
                <el-input v-model="form.ccustomerlinktel" placeholder="请输入手机"></el-input>
                <el-button size="mini" type="success" class="fsyzm" @click="SendCode()" :disabled="fsyzmif">{{ fsyzm
                  }}</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="验证码:" prop="cnote">
                <el-input v-model="form.cnote" placeholder="请输入验证码"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="法人:" prop="clegal">
                <el-input v-model="form.clegal" placeholder="请输入法人真实姓名"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="证件类型:" prop="czjtype">
                <el-select v-model="form.czjtype" placeholder="请选择">
                  <el-option label="大陆身份证" value="大陆身份证"></el-option>
                  <el-option label="香港身份证" value="香港身份证"></el-option>
                  <el-option label="护照" value="护照"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="证件号:" prop="cidcode">
                <el-input v-model="form.cidcode" placeholder="请输入证件号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="成立日期:" prop="dcldate">
                <el-date-picker v-model="form.dcldate" type="date" placeholder="选择日期" key="lday"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公司电话:" prop="ccorptel">
                <el-input v-model="form.ccorptel" placeholder="请输入公司电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业属性:" prop="centerpriseproperty">
                <el-select v-model="form.centerpriseproperty" placeholder="请选择">
                  <el-option label="生产商（总公司）" value="生产商（总公司）"></el-option>
                  <el-option label="生产商（分公司）" value="生产商（分公司）"></el-option>
                  <el-option label="贸易商（总代理）" value="贸易商（总代理）"></el-option>
                  <el-option label="贸易商（区域代理）" value="贸易商（区域代理）"></el-option>
                  <el-option label="个体工商户" value="个体工商户"></el-option>
                  <el-option label="自然人" value="自然人"></el-option>
                  <el-option label="服务" value="服务"></el-option>
                  <el-option label="工程建筑" value="工程建筑"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="公司地址:" prop="ccustomeraddress">
                <el-input v-model="form.ccustomeraddress" maxlength="500" placeholder="请输入公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="网址:" prop="chttp">
                <el-input v-model="form.chttp" placeholder="请输入网址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否境外:" prop="ichina">
                <el-select v-model="form.ichina" placeholder="请选择">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮箱:" prop="cemail">
                <el-input v-model="form.cemail" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="城市:" prop="ccity">
                <el-input v-model="form.ccity" placeholder="请输入城市"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮编:" prop="ccorpemail">
                <el-input v-model="form.ccorpemail" placeholder="请输入邮编"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="传真:" prop="ccorpfax">
                <el-input v-model="form.ccorpfax" placeholder="请输入传真"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册资本(万元):" prop="cenrollmentcapital">
                <el-input v-model="form.cenrollmentcapital" oninput="value=value.replace(/[^\d.]/g,'')"
                  placeholder="请输入注册资本(万元)" @blur="salaryChange($event,'cenrollmentcapital')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="币种:" prop="cmoneytype">
                <el-select v-model="form.cmoneytype" placeholder="请选择">
                  <el-option label="人民币" value="人民币"></el-option>
                  <!-- <el-option label="美元" value="美元"></el-option> -->
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="16">
              <el-form-item label="银行名称:" prop="cbankname">
                <el-input v-model="form.cbankname" placeholder="请选择或者输入银行名称" disabled></el-input>
                <el-button size="mini" type="success" class="fsyzm" @click="GetBankList()">选择银行</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="银行行号:" prop="cbankcode">
                <el-input v-model="form.cbankcode" placeholder="请输入银行行号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="银行账号:" prop="cbankaccount">
                <el-input v-model="form.cbankaccount" placeholder="请输入银行账号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账号持有人:" prop="ckoinh">
                <el-input v-model="form.ckoinh" placeholder="请输入账号持有人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="提报年份:" prop="ilastyearmoney">
                <el-input v-model="form.ilastyearmoney" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入年份"
                  @blur="salaryChange($event,'ilastyearmoney')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="营业总额（万元）:" prop="isummoney">
                <el-input v-model="form.isummoney" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入总额（万元）"
                  @blur="salaryChange($event,'isummoney')"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="上年净利润(万元):" prop="ilastyearprofit">
                <el-input v-model="form.ilastyearprofit" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入年份"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="利润总额（万元）:" prop="isumprofitmoney">
                <el-input v-model="form.isumprofitmoney" oninput="value=value.replace(/[^\d.]/g,'')"
                  placeholder="请输入总额（万元）" @blur="salaryChange($event,'isumprofitmoney')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业人数:" prop="ifirmnumber">
                <el-input v-model="form.ifirmnumber" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入企业人数"
                  @blur="salaryChange($event,'ifirmnumber')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="技术研发人数:" prop="irdnumber">
                <el-input v-model="form.irdnumber" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入技术研发人数"
                  @blur="salaryChange($event,'irdnumber')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="质量管理人数:" prop="imanagenumber">
                <el-input v-model="form.imanagenumber" oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="请输入质量管理人数" @blur="salaryChange($event,'imanagenumber')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="售后人数:" prop="iaftersalenumber">
                <el-input v-model="form.iaftersalenumber" oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="请输入售后人数" @blur="salaryChange($event,'iaftersalenumber')"></el-input>
              </el-form-item>
            </el-col>



            <el-col :span="8">
              <el-form-item label="牧场负责人:" prop="cprincipalcode">
                <el-select v-model="form.cprincipalcode" placeholder="请选择牧场负责人" clearable @change="cprincipalchange">
                  <el-option v-for="list in cprincipallist" :key="list.cprincipalcode" :label="list.cprincipal"
                    :value="list.cprincipalcode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司简介:" label-width="100%" style="margin-bottom: 0" class="itemcenter">
                <span class="corspan">*</span>
              </el-form-item>
              <el-form-item prop="ccorpintroduction" label-width="0">
                <el-input type="textarea" v-model="form.ccorpintroduction" maxlength="500" placeholder="请输入公司简介"
                  rows="4" style="width: 100%" @input="descinput"></el-input>
                <span class="corpint">{{ this.remnant }}/500</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="业绩案例:" label-width="100%" style="margin-bottom: 0" class="itemcenter">
                <span class="corspan">*</span>
              </el-form-item>
              <el-form-item prop="cperformancecase" label-width="0">
                <el-input type="textarea" v-model="form.cperformancecase" placeholder="请输入业绩案例" maxlength="200" rows="4" @input="cpecinput" style="width: 100%"></el-input>
                <span class="corpint">{{ this.cperremnant }}/200</span>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>

        <usertable :sdatable="sdatable" @sdalist="sdalist" v-if="!loading" style="margin-bottom:30px" />

        <anlitable :anlitable="anlitable" :urlid="urlid" @anlilist="anlilist" v-if="!loading"
          style="margin-bottom:30px" />
        <comtable :assotbale="assotbale" @assolist="assolist" v-if="!loading" />
      </div>
      <el-dialog title="银行" :visible.sync="dialogFormVisible" customClass="way sadform1" :append-to-body="true"
        v-loading="loading">
        <div style="width:100%" class="pull-left">
          <el-form :inline="true" :model="banklist" class="demo-form-inline">
            <el-form-item label="银行名称">
              <el-input v-model="banklist.cbankname" placeholder="银行名称"></el-input>
            </el-form-item>

            <el-form-item>
              <Debounce :time='300' :isDebounce="1">
                <el-button type="primary" @click.native="GetBankList()" size="medium">查询</el-button>
              </Debounce>
            </el-form-item>
          </el-form>
          <el-table :data="yinhanglist" border style="width: 100%" @current-change="clickChange" tooltip-effect
            :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="选择" width="55">
              <template slot-scope="scope">
                <el-radio v-model="tablerow" :label="scope.row">
                  <i>
                  </i>
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="cbankcode" label="编号" width="140"></el-table-column>
            <el-table-column prop="cbankname" label="银行名称"></el-table-column>
            <el-table-column prop="cbankcontray" label="国家" width="140"></el-table-column>
          </el-table>
          <div class="pull-right" style="padding:20px">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[10,20, 50, 100, 1000]" :page-size="banklist.pageSize"
              layout="total, sizes, prev, pager, next" :total="banklist.totalCount">
            </el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closesad()">取 消</el-button>
          <el-button type="success" @click="banksubmit()">确 定</el-button>
        </div>
      </el-dialog>
      <div class="zc_btn">
        <el-button type="success" round @click="prereturn()">上一步</el-button>
        <el-button type="success" round @click="clickSubmit()">下一步</el-button>
      </div>
    </div>
    <div class="protocol-accept"></div>
  </div>
</template>

<script>
  import anlitable from "./useregister/anlitable.vue";
  import usertable from "./useregister/usertable.vue";
  import comtable from "./useregister/comtable.vue";
  export default {
    components: {
      usertable,
      comtable,
      anlitable,
    },
    data() {
      var uid = this.$route.query.id;
      console.log(uid);
      if (uid == undefined) {
        uid = "";
      }
      var namevail = async (rule, value, callback) => {
        await this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/CheckSupplier",
          data: { ccustomername: value, KeyValue: uid },
        }).then((res) => {
          console.log(res, 12334445);
          if (!res.data.Success) {
            callback(new Error("该公司名称已经注册，请重新输入名称"));
          } else {
            callback();
          }
        });
      };
      var ccredit = async (rule, value, callback) => {
        await this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/CheckSupplier",
          data: { ccredit: value, KeyValue: uid },
        }).then((res) => {
          if (!res.data.Success) {
            callback(new Error("该信用代码已经注册，请重新输入信用代码"));
          } else {
            callback();
          }
        });
      };

      var validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.form.cpassword) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };

      var email = (rule, value, callback) => {
        var patterns =
          /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
        if (!patterns.test(value)) {
          callback(new Error("邮箱输入有误"));
        } else {
          callback();
        }
      };

      return {
        loading: false,
        fsyzm: "发送验证码",
        // 倒计时
        countdown: 60,
        // 不能重复点击
        fsyzmif: false,
        // 关联企业
        assotbale: [],
        // 企业联系人
        sdatable: [],
        // 企业案例
        anlitable: [],
        urlid: "",
        form: {
          ccustomername: "",
          ccredit: "",
          caccount: "",
          ccustomerabb: "",
          cformername: "",
          ccustomerlinktel: "",
          cpassword: "",
          crepassword: "",
          clegal: "",
          cprincipalcode: "",
          cprincipal: "",
          cvenoper: "",
          czjtype: "大陆身份证",
          centerpriseproperty: "",
          cidcode: "",
          dcldate: "",
          ccorptel: "",
          ccustomeraddress: "",
          chttp: "",
          ichina: "否",
          cemail: "",
          ccity: "",
          ccorpemail: "",
          ccorpfax: "",
          cenrollmentcapital: "",
          cmoneytype: "人民币",
          cbankname: "",
          cbankcode: "",
          cbankcontray: "",
          cbankcontray: "",
          cbkref: "",
          cbankaccount: "",
          ilastyearmoney: "",
          isummoney: "",
          // ilastyearprofit: "",
          isumprofitmoney: "",
          ifirmnumber: "",
          irdnumber: "",
          imanagenumber: "",
          iaftersalenumber: "",
          ccorpintroduction: "",
          ckoinh: "",
        },
        rules: {
          ccustomername: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { validator: namevail, trigger: "blur" },
          ],
          ccredit: [
            { required: true, message: "请输入信用代码", trigger: "blur" },
            { validator: ccredit, trigger: "blur" },
          ],
          caccount: [{ required: true, message: "请输入账户", trigger: "blur" }],
          ccustomerabb: [
            { required: true, message: "请输入简称", trigger: "blur" },
          ],
          cprincipalcode: [
            { required: true, message: "请输入牧场负责任", trigger: "change" },
          ],
          ccustomerlinktel: [
            { required: true, message: "请输入手机", trigger: "blur" },
          ],
          cnote: [{ required: true, message: "请输入验证码", trigger: "blur" }],
          cpassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
          crepassword: [
            { required: true, message: "请再次输入密码", trigger: "blur" },
            { validator: validatePass2, trigger: "blur" },
          ],
          clegal: [
            { required: true, message: "请输入法人真实姓名", trigger: "blur" },
          ],
          cvenoper: [
            { required: true, message: "请输入联系人真实姓名", trigger: "blur" },
          ],
          czjtype: [
            { required: true, message: "请选择证件类型", trigger: "blur" },
          ],
          cidcode: [{ required: true, message: "请输入证件号", trigger: "blur" }],
          dcldate: [
            { required: true, message: "请选择成立日期", trigger: "blur" },
          ],
          ccorptel: [
            { required: true, message: "请输入公司电话", trigger: "blur" },
          ],
          centerpriseproperty: [
            { required: true, message: "请选择企业属性", trigger: "blur" },
          ],
          ccustomeraddress: [
            { required: true, message: "请输入公司地址", trigger: "blur" },
          ],

          ichina: [
            { required: true, message: "请选择是否境外", trigger: "blur" },
          ],
          cemail: [
            { required: true, message: "请输入邮箱", trigger: "blur" },
          ],
          ccity: [{ required: true, message: "请输入城市", trigger: "blur" }],
          cenrollmentcapital: [
            {
              required: true,
              message: "请输入注册资本",
              trigger: "blur",
            },
          ],
          cmoneytype: [
            { required: true, message: "请选择币种", trigger: "blur" },
          ],
          cbankname: [
            { required: true, message: "请输入银行名称", trigger: "blur" },
          ],
          cbankcode: [
            { required: true, message: "请输入银行编号", trigger: "blur" },
          ],
          cbankaccount: [
            { required: true, message: "请输入银行账号", trigger: "blur" },
          ],
          ckoinh: [
            { required: true, message: "请输入账号持有人", trigger: "blur" },
          ],
          ccorpemail: [
            { required: true, message: "请输入邮编", trigger: "blur" },
          ],
          ilastyearmoney: [
            {
              required: true,
              message: "请输入提报年份",
              trigger: "blur",
            },
          ],
          isummoney: [
            {
              required: true,
              message: "请输入营业总额（万）",
              trigger: "blur",
            },
          ],
          // ilastyearprofit: [
          //   { required: true, message: "请输入上年净利润", trigger: "blur" },
          // ],
          isumprofitmoney: [
            {
              required: true,
              message: "请输入利润总额（万）",
              trigger: "blur",
            },
          ],
          ifirmnumber: [
            {
              required: true,
              message: "请输入企业人数",
              trigger: "blur",
            },
          ],
          irdnumber: [
            {
              required: true,
              message: "请输入技术研发人数",
              trigger: "blur",
            },
          ],
          imanagenumber: [
            {
              required: true,
              message: "请输入质量管理人数",
              trigger: "blur",
            },
          ],
          iaftersalenumber: [
            {
              required: true,
              message: "请输入售后人数",
              trigger: "blur",
            },
          ],
          ccorpintroduction: [
            {
              required: true,
              message: "请输入公司简介",
              trigger: "blur",
            },
            { min: 0, max: 500, message: "长度在 500 个字符", trigger: "blur" },
          ],
          // cperformancecase: [
          //   {
          //     required: true,
          //     message: "请输入业绩案例",
          //     trigger: "blur",
          //   },
          //   { min: 0, max: 200, message: "长度在 200 个字符", trigger: "blur" },
          // ],
        },
        cnoteif: false,
        remnant: 0,
        cperremnant: 0,
        yinhanglist: [],
        urlid: "",
        tablerow: {},
        dialogFormVisible: false,
        loading: false,
        banklist: {
          cbankname: "",
          // 分页
          pageSize: 5,
          pageIndex: 1,
          // 页数
          totalCount: 0,
        },
        // 厂商负责人
        cprincipallist: [],
      };
    },
    created() {
      var d = new Date();
      this.form.ilastyearmoney = d.getFullYear();
      // this.form.ilastyearprofit = d.getFullYear() - 1;
      this.urlid = this.$route.query.id;

      if (this.urlid != undefined) {
        this.GetVendorInfos(this.urlid);
      } else {
        this.urlid = "";
      }
      this.getcprincipal();
      console.log(this.urlid);
    },
    methods: {
      // 牧场负责人点击
      cprincipalchange(val) {
        this.$set(this.form, 'cprincipalcode', val)
        this.$forceUpdate()
      },
      salaryChange(e, name) {
        if (name == "isumprofitmoney") {
          this.form.isumprofitmoney = e.target.value;
        }
        if (name == "ilastyearmoney") {
          this.form.ilastyearmoney = e.target.value;
        }
        if (name == "isummoney") {
          this.form.isummoney = e.target.value;
        }
        if (name == "ifirmnumber") {
          this.form.ifirmnumber = e.target.value;
        }
        if (name == "irdnumber") {
          this.form.irdnumber = e.target.value;
        }
        if (name == "imanagenumber") {
          this.form.imanagenumber = e.target.value;
        }
        if (name == "iaftersalenumber") {
          this.form.iaftersalenumber = e.target.value;
        }
        if (name == "cenrollmentcapital") {
          this.form.cenrollmentcapital = e.target.value;
        }
      },
      // 判断文字是否超出
      descinput() {
        const txtval = this.form.ccorpintroduction.length;
        this.remnant = txtval;
        if (txtval > 500) {
          this.$message.error("文本超出500个字");
          return;
        }
      },
      // 获取厂商负责人
      getcprincipal() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetCustomerPrincipal",
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.cprincipallist = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // // 判断文字是否超出
      // cpecinput() {
      //   const txtval = this.form.cperformancecase.length;
      //   this.cperremnant = txtval;
      //   if (txtval > 200) {
      //     this.$message.error("文本超出200个字");
      //     return;
      //   }
      // },
      // 如果url上有id,查询
      GetVendorInfos(publicid) {
        this.loading = true;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetVendorInfos",
          data: { KeyValue: publicid },
        }).then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.Success) {
            if (res.data.Message) {
              this.$message.error(res.data.Message);
            }
            if (res.data.Data != "") {
              if (res.data.Data.rows1.length != 0) {
                this.form = res.data.Data.rows1[0];

                this.$set(this.form, "crepassword", this.form.cpassword);
                this.$set(this.form, "cnote", "");
                if (this.form.cenrollmentcapital != "") {
                  this.form.cenrollmentcapital = parseFloat(
                    this.form.cenrollmentcapital
                  );
                }
                if (this.form.ilastyearmoney != "") {
                  this.form.ilastyearmoney = parseInt(this.form.ilastyearmoney);
                }
                if (this.form.isummoney != "") {
                  this.form.isummoney = parseFloat(this.form.isummoney);
                }
                if (this.form.isumprofitmoney != "") {
                  this.form.isumprofitmoney = parseFloat(
                    this.form.isumprofitmoney
                  );
                }
                if (this.form.irdnumber != "") {
                  this.form.irdnumber = parseInt(this.form.irdnumber);
                }
                if (this.form.imanagenumber != "") {
                  this.form.imanagenumber = parseInt(this.form.imanagenumber);
                }
                if (this.form.iaftersalenumber != "") {
                  this.form.iaftersalenumber = parseInt(
                    this.form.iaftersalenumber
                  );
                }
                if (this.form.ifirmnumber != "") {
                  this.form.ifirmnumber = parseInt(this.form.ifirmnumber);
                }

                this.sdatable = [];
                this.assotbale = [];
                this.sdatable = res.data.Data.rows2;
                console.log(this.sdatable);
                this.assotbale = res.data.Data.rows3;
                this.anlitable = [];
                this.anlitable = res.data.Data.rows4;
              }
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 去重
      unique(arr) {
        const res = new Map();
        return arr.filter(
          (arr) => !res.has(arr.cbankcode) && res.set(arr.cbankcode, 1)
        );
      },
      // 子组件传值
      anlilist(val) {
        this.anlitable = val;
      },
      // 子组件传值
      sdalist(val) {
        this.sdatable = val;
        console.log(this.sdatable);
      },
      //子组件传值
      assolist(val) {
        this.assotbale = val;
      },

      CheckNote() {
        if (this.form.ccustomerlinktel != "") {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/CheckNote",
            data: { ctel: this.form.ccustomerlinktel, note: this.form.cnote },
          }).then((res) => {
            console.log(res);
            if (res.data.Success) {
              this.cnoteif = true;
            } else {
              this.$message.error(res.data.Message);
              this.cnoteif = false;
            }
          });
        } else {
          this.$message.error("请输入手机号");
        }
      },
      //  获取银行信息接口
      GetBankList() {
        this.loading = true;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetBankList",
          data: {
            value: this.banklist.cbankname,
            pageSize: this.banklist.pageSize,
            pageIndex: this.banklist.pageIndex,
          },
        }).then((res) => {
          this.loading = false;
          console.log(res, "获取银行信息接口");
          if (res.data.Success) {
            this.yinhanglist = res.data.Data.rows;
            this.banklist.totalCount = res.data.Data.totalCount;
            this.dialogFormVisible = true;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //关闭
      closesad() {
        this.tablerow = {};
        this.dialogFormVisible = false;
      },
      //确认
      banksubmit() {
        console.log(this.tablerow);
        if (this.tablerow.cbankname) {
          this.form.cbankname = this.tablerow.cbankname;
          this.form.cbankcode = this.tablerow.cbankcode;
          this.form.cbankcontray = this.tablerow.cbankcontray;
          this.dialogFormVisible = false;
        } else {
          this.$message.error("请选择银行信息！");
        }
      },
      // 单选
      clickChange(item) {
        this.tablerow = item;
        console.log(this.tablerow);
      },
      // 分页
      handleSizeChange(val) {
        this.banklist.pageSize = val;
        this.GetBankList();
      },
      // 分页
      handleCurrentChange(val) {
        this.banklist.pageIndex = val;
        this.GetBankList();
      },
      //提交前走
      accout() {
        this.form.caccount = this.form.ccustomername;
      },

      //发送验证码
      SendCode() {
        var ccustomerlinktel = this.form.ccustomerlinktel;
        if (!ccustomerlinktel) {
          this.$message.error("请输入联系人手机号码");
          return;
        } else {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/SendCode",
            data: { ctelphone: ccustomerlinktel },
          }).then((res) => {
            console.log(res);
            if (res.data.Code == "1" || res.data.Code == "-1") {
              var sert = setInterval(() => {
                if (this.countdown == 0) {
                  this.fsyzmif = false;
                  this.fsyzm = "获取验证码";
                  this.countdown = 600;
                  clearInterval(sert);
                  return;
                } else {
                  this.fsyzmif = true;
                  this.fsyzm = "重新发送(" + this.countdown + ")";
                  this.countdown--;
                }
              }, 1000);
              this.$message.success(res.data.Message);
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      // 返回上一步
      prereturn() {
        this.$router.push("/dlxxregister");
      },
      clickSubmit() {
        for (let a = 0; a < this.cprincipallist.length; a++) {
          if (this.form.cprincipalcode == this.cprincipallist[a].cprincipalcode) {
            this.form.cprincipal = this.cprincipallist[a].cprincipal;
          }
        }
        if (this.form.cbankcontray == "") {
          this.form.cbankcontray = "CN";
        }
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            //账户持有人验证
            if (this.form.ckoinh != this.form.ccustomername) {
              this.$message.error("账户持有人需要和公司名称保持一致");
              return;
            }
            //  身份证号验证
            if (this.form.czjtype == "大陆身份证") {
              var pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              if (!pattern.test(this.form.cidcode)) {
                this.$message.error("请输入有效的证件号");
                return;
              }
            } else if (this.czjtype == "香港身份证") {
              var zz = /^[A-Z]\d{6}\([\dA]\)$/;
              if (!zz.test(this.form.cidcode)) {
                this.$message.error("请输入有效的证件号");
                return;
              }
            }

            var patrn = /^[0-9A-Z]+$/;
            //18位校验及大写校验
            if (
              this.form.ccredit.length != 18 ||
              patrn.test(this.form.ccredit) == false
            ) {
              this.$message.error("不是有效的统一社会信用编码！");
              return;
            } else {
              var Ancode; //统一社会信用代码的每一个值
              var Ancodevalue; //统一社会信用代码每一个值的权重
              var total = 0;
              var weightedfactors = [
                1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28,
              ]; //加权因子
              var str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
              //不用I、O、S、V、Z
              for (var i = 0; i < this.form.ccredit.length - 1; i++) {
                Ancode = this.form.ccredit.substring(i, i + 1);
                Ancodevalue = str.indexOf(Ancode);
                total = total + Ancodevalue * weightedfactors[i];
                //权重与加权因子相乘之和
              }
              var logiccheckcode = 31 - (total % 31);
              if (logiccheckcode == 31) {
                logiccheckcode = 0;
              }
              var Str =
                "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
              var Array_Str = Str.split(",");
              logiccheckcode = Array_Str[logiccheckcode];

              var checkcode = this.form.ccredit.substring(17, 18);

              if (logiccheckcode != checkcode) {
                this.$message.error("不是有效的统一社会信用编码！");
                return;
              }
            }
            if (this.form.chttp != "") {
              var patterns =
                /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/i;
              if (!patterns.test(this.form.chttp)) {
                this.$message.error("规则为 http://www.xxx.com 或 www.xxx.com");
                return;
              }
            }

            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/CheckNote",
              data: { ctel: this.form.ccustomerlinktel, note: this.form.cnote },
            }).then((res) => {
              console.log(res);
              if (res.data.Success) {
                if (this.sdatable.length != 0) {
                  this.clickvial();
                } else {
                  this.$message.error("企业联系人不能为空");
                  return;
                }
              } else {
                this.$message.error(res.data.Message);

                return;
              }
            });
          } else {
            this.$message.error("请查看信息是否填写完整");
            return false;
          }
        });
      },
      clickvial() {
        var formData = new FormData();
        console.log(this.form);
        formData.append("infoJson", escape(JSON.stringify(this.form)));
        if (this.urlid != undefined) {
          formData.append("KeyValue", this.urlid);
        }
        console.log(this.form, this.urlid);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/Storage",
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.urlid = res.data.Data;
            this.SaveLink(res.data.Data);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      SaveLink(id) {
        // console.log(this.sdatable);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveLink",
          data: { KeyValue: id, infoJson: JSON.stringify(this.sdatable) },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            if (this.anlitable.length != 0) {
              this.SaveAnLi(id);
            } else {
              this.$message.error("公司案例不能为空");
              this.$router.push({ path: "/useregister", query: { id: id } });

              window.location.reload();
            }
          } else {
            this.$message.error(res.data.Message);
            this.$router.push({ path: "/useregister", query: { id: id } });
            // alert(id)
          }
        });
      },
      SaveAnLi(id) {
        console.log(this.anlitable);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveAnLi",
          data: { KeyValue: id, infoJson: JSON.stringify(this.anlitable) },
        })
          .then((res) => {
            console.log(res, "anli");
            if (res.data.Success) {
              if (this.assotbale.length != 0) {
                this.SaveFirm(id);
              } else {
                this.$confirm(
                  "银行账户信息不能有空格和特殊符号,不然会影响付款!!!",
                  {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                  }
                ).then(() => {
                  // this.$message({
                  //   type: "info",
                  //   message: "确定",
                  // });
                  this.$router.push({ path: "/SupplyObject", query: { id: id } });
                });
              }
            } else {
              this.SaveFirm(id);
              window.location.reload();
            }
          })
          .catch((error) => {
            this.SaveFirm(id);
          });
        //  var formData = new FormData();
        //  formData.append("infoJson", escape(JSON.stringify(this.sdatable)));
        //  formData.append("KeyValue", id);
      },
      SaveFirm(id) {
        console.log(this.assotbale);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveFirm",
          data: { KeyValue: id, infoJson: JSON.stringify(this.assotbale) },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$confirm("银行账户信息不能有空格和特殊符号,不然会影响付款!!!", {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }).then(() => {
              // this.$message({
              //   type: "info",
              //   message: "确定",
              // });
              this.$router.push({ path: "/SupplyObject", query: { id: id } });
            });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
    mounted() { },
  };
</script>
<style scoped>
  @import url(../../assets/css/reg.css);
</style>